import { isMoment } from 'moment';
import 'moment-timezone';

export default ['currentPropertyService', (currentPropertyService) => {
    const timeCheck = function (time) {
        if (!isMoment(time)) {
            time = moment.utc(time);
        }
        return time.tz(currentPropertyService.get().timezone);
    };

    const readableTime = (input) => timeCheck(input).format('MMMM Do YYYY, h:mm:ss A');
    const readableDate = (input) => timeCheck(input).format('MMMM Do YYYY');
    const shortTime = (input) => timeCheck(input).format('D/M/Y HH:mm');
    const shortDate = (input) => timeCheck(input).format('D/M/Y');
    const readable = (input, format) => timeCheck(input).format(format);

    return {
        readableTime,
        readableDate,
        shortTime,
        shortDate,
        readable
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/base/services/time.service.js